import React from 'react';
import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { List } from '../group/Group';

const ellipsisByLinesCss = lines => css`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: ${lines};
  -webkit-box-orient: vertical;
`;

const MetaContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 16px;
  flex: 1 0;
`;

const Title = styled.h3`
  ${ellipsisByLinesCss(themeGet('card.title.lineClamp'))}
  margin: 8px 0;
  line-height: 1.5;
  color: ${themeGet('card.title.color')};
  font-size: ${themeGet('card.title.fontSize')};
`;

const Description = styled.p`
  ${props => ellipsisByLinesCss(props.lineClamp || themeGet('card.description.lineClamp'))}
  margin: 0 0 ${themeGet('card.description.marginBottom')};
  line-height: 1.5;
  color: ${themeGet('card.description.color')};
  font-size: ${themeGet('card.description.fontSize')};
`;

const Content = styled.div`
  & > ${List} {
    margin-bottom: 16px;
  }
`;

export const Meta = ({ title, description, children, descriptionLineClamp, ...rest }) => (
  <MetaContent {...rest}>
    <div>
      {title && <Title>{title}</Title>}
      {description && <Description lineClamp={descriptionLineClamp}>{description}</Description>}
    </div>
    <Content>{children}</Content>
  </MetaContent>
);
